import { defu } from "defu";
import {
  authentication,
  createDirectus,
  realtime,
  graphql,
  rest
} from "@directus/sdk";
import { useDirectusTokens } from "./use-directus-tokens.mjs";
import { useRuntimeConfig } from "#imports";
export const useDirectus = (options) => {
  const { url } = useRuntimeConfig().public.directus;
  const config = defu(options, {
    baseURL: url,
    clientOptions: {
      globals: {
        fetch: $fetch.create({
          onRequestError: ({ request, options: options2, error }) => {
            if (import.meta.dev) {
              console.error("Request error:", request, options2, error);
            }
          },
          onResponseError: ({ request, options: options2, response, error }) => {
            if (import.meta.dev) {
              console.error("Response error:", request, options2, response, error);
            }
          }
        })
      }
    }
  });
  if (!config.baseURL) {
    throw new Error("Please provide a Directus URL either via Nuxt runtimeConfig or via the options parameter.");
  }
  return createDirectus(config.baseURL, config.clientOptions);
};
export const useDirectusRest = (options) => {
  const { mode } = useRuntimeConfig().public.directus.authConfig;
  const config = defu(options, {
    authConfig: {
      autoRefresh: true,
      msRefreshBeforeExpires: 1e3 * 60 * 5,
      credentials: "include",
      storage: useDirectusTokens(options?.staticToken)
    },
    restConfig: {
      credentials: "include"
    }
  });
  return useDirectus(config?.options).with(authentication(mode, config.authConfig)).with(rest(config?.restConfig));
};
export const useDirectusGraphql = (options) => {
  const { mode } = useRuntimeConfig().public.directus.authConfig;
  const config = defu(options, {
    authConfig: {
      autoRefresh: true,
      msRefreshBeforeExpires: 1e3 * 60 * 5,
      credentials: "include",
      storage: useDirectusTokens(options?.staticToken)
    },
    graphqlConfig: {
      credentials: "include"
    }
  });
  return useDirectus(config?.options).with(authentication(mode, config.authConfig)).with(graphql(config.graphqlConfig));
};
export const useDirectusRealtime = (options) => {
  const { mode } = useRuntimeConfig().public.directus.authConfig;
  const config = defu(options, {
    authConfig: {
      autoRefresh: true,
      msRefreshBeforeExpires: 1e3 * 60 * 5,
      credentials: "include",
      storage: useDirectusTokens(options?.staticToken)
    }
  });
  return useDirectus(config?.options).with(authentication(mode, config.authConfig)).with(realtime(config?.websocketConfig));
};
